import { LoadingSpinner } from '../../../generic/Loading';

const ModalLoader = () => (
  <div className="move-xblock-modal-loading">
    <LoadingSpinner />
  </div>
);

export default ModalLoader;
